import styled from 'styled-components';

export const DetailsHeaderStyled = styled(`p`)`
	margin-bottom: 8px;
	color: #77818e;
	font-weight: 400;
	font-size: 14px;
`;

export const DetailsTextStyled = styled(`p`)`
	margin: 0;
	font-weight: 400;
	font-size: 14px;
`;

export const InfoContainerStyled = styled(`div`)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 48px 0;
	width: 100%;
	height: 56px;
`;

export const DetailsItemStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 25%;
	text-align: left;
`;

export const SeparatorStyled = styled(`div`)`
	width: 1px;
	height: 100%;
	background-color: #77818e;
`;
